import { Fragment, useState } from "react";
import { EmailBodyMarkupMapper } from "../emailBodyMarkupMapper";
import { useQuoteCopy } from "../i18n/QuoteCopyContext";
import { ChevronDownIcon } from "./icons";

interface Props {
  subject: string;
  bodyHtml: string;
}

const emailBodyMarkupMapper = new EmailBodyMarkupMapper();

export function EmailPreview({ subject, bodyHtml }: Props) {
  const copy = useQuoteCopy();
  const [open, setOpen] = useState(true);
  const segments = emailBodyMarkupMapper.map(bodyHtml);
  return (
    <div className="nv-preview">
      <button
        type="button"
        className="nv-preview-toggle"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <ChevronDownIcon size={16} className={open ? "open" : undefined} />
        {open ? copy.t("result.hideDetails") : copy.t("result.viewSent")}
      </button>
      {open && (
        <div className="nv-preview-body">
          <div className="nv-preview-subject">{subject}</div>
          <div className="email-body">
            {segments.map((segment, index) => {
              if (segment.kind === "strong") {
                return <strong key={index}>{segment.value}</strong>;
              }
              if (segment.kind === "highlight") {
                return (
                  <span key={index} className="nv-email-hl">
                    {segment.value}
                  </span>
                );
              }
              return <Fragment key={index}>{segment.value}</Fragment>;
            })}
          </div>
        </div>
      )}
    </div>
  );
}
